import { FC } from "react";
import styles from "./styles.module.css";
import { Col, Row } from "antd";
import BannerCenter from "./components/BannerCenter";
import Card from "./components/Card";

const Banner: FC = () => {
  return (
    <section
      style={{ backgroundImage: `url("/images/landing_v2/background.webp")` }}
      className={styles.root}
    >
      <div className="container-lg">
        <Row>
          <Col span={24}>
            <BannerCenter />
          </Col>

          <Col xs={24}>
            <Row
              gutter={[24, 48]}
              justify="space-between"
              className={styles.cardWrapper}
            >
              <Col xs={24} md={12} lg={6}>
                <Card
                  type="build"
                  src="/images/landing_v2/tool.png"
                  title="BUIDL"
                >
                  Create or join projects, find collaborators and just{" "}
                  <b>BUIDL!</b>
                </Card>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <Card
                  type="network"
                  src="/images/landing_v2/network.png"
                  title="NETWORK"
                >
                  Find passionate <br /> <b>co-founders</b> for your next
                  project, renowned mentors or even your <b>next job!</b>
                </Card>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <Card
                  type="portfolio"
                  src="/images/landing_v2/portfolio.png"
                  title="PORTFOLIO"
                >
                  Show off your skills! Easily{" "}
                  <b>create and share your portfolio!</b>
                </Card>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <Card
                  type="funding"
                  src="/images/landing_v2/funding.png"
                  title="FUNDING"
                >
                  Validate your ideas & receive <b>funding</b> from{" "}
                  <b>real investors</b> or <b>community DAOs</b>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Banner;
